import type { Config } from "driver.js";

export const DRIVER_GERMAN_CONFIG: Partial<Config> = {
  showProgress: true,
  progressText: "{{current}} von {{total}}",
  nextBtnText: "Weiter",
  prevBtnText: "Zurück",
  doneBtnText: "Fertig",
  allowClose: true,
  overlayOpacity: 0.55,
  stagePadding: 8,
  stageRadius: 12,
  popoverOffset: 12,
  animate: true,
};
